import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar as CalIcon } from "lucide-react";

// react-datepicker does not forward data-* props to its internal input, so we
// supply a custom input (module-scope so React keeps the same component type)
// that carries the data-testid used by automated tests.
const DtInput = React.forwardRef(function DtInput(props, ref) {
  return <input ref={ref} {...props} />;
});

/** Dark/gold themed datetime picker. Replaces native datetime-local. */
export default function DateTimePicker({ value, onChange, testId = "datetime-picker", minDate = new Date() }) {
  const date = value ? new Date(value) : null;

  return (
    <div className="dlx-dtpicker relative" data-testid={`${testId}-wrapper`}>
      <DatePicker
        selected={date}
        onChange={d => {
          if (!d) return onChange("");
          // Format as ISO local datetime (YYYY-MM-DDTHH:mm)
          const pad = (n) => String(n).padStart(2, "0");
          const iso = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
          onChange(iso);
        }}
        showTimeSelect
        timeIntervals={15}
        timeCaption="Time"
        dateFormat="MMM d, yyyy — h:mm aa"
        placeholderText="Select date & time"
        minDate={minDate}
        className="field-input pr-10 cursor-pointer"
        wrapperClassName="w-full"
        popperClassName="dlx-popper"
        calendarClassName="dlx-cal"
        customInput={<DtInput data-testid={testId} />}
      />
      <CalIcon size={14} className="absolute right-2 top-3.5 text-[#D4AF37] pointer-events-none"/>
    </div>
  );
}
